import { Button } from '@mantine/core'

export const ButtonConfig = Button.extend({
  defaultProps: {
    size: 'md',
    variant: 'default',
  },
})
